const dummyNotesData = [
  {
    id: '0',
    subject: 'Machine Learning',
    desc: 'Earum ullam  orem ipsum Lorem ipsum,  sunt?',
    views: 133,
    time: '2022-04-10T10:27:22.003+00:00',
    rating: 4.8,
  },
  {
    id: '1',
    subject: 'Linear Algebra',
    desc: 'Lorem ipsum, dolor sit amet  elit. qui sunt?',
    views: 67,
    time: '2022-07-10T10:27:22.003+00:00',
    rating: 3.2,
  },
  {
    id: '2',
    subject: 'Maths for CS',
    desc: 'adipisicing elit. Earum u  sunt?',
    views: 37,
    time: '2022-06-10T10:27:22.003+00:00',
    rating: 4.9,
  },
  {
    id: '3',
    subject: 'Phy for IT',
    desc: 'Lonsectetur adipisicing , dolor sit ',
    views: 97,
    time: '2021-07-10T10:27:22.003+00:00',
    rating: 4.5,
  },
  {
    id: '4',
    subject: 'Machine Learning',
    desc: 'Earum ullam  , maiores qui sunt?',
    views: 133,
    time: '2022-04-10T10:27:22.003+00:00',
    rating: 4.8,
  },
  {
    id: '5',
    subject: 'Machine Learning',
    desc: 'Earum ullam  orem , maiores qui sunt?',
    views: 133,
    time: '2022-04-10T10:27:22.003+00:00',
    rating: 4.8,
  },
];

export default dummyNotesData;
